<template>
  <div class="p-0 search-input-container">
    <div class="search-container">
      <input class="search-input" v-model="search" :placeholder="placeholder" />
      <div class="icon">
        <svg
          class="frame-4820"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.6337 12.8767C7.94842 12.8767 9.17603 12.4285 10.1739 11.6814L13.928 15.616C14.1023 15.7986 14.332 15.8899 14.5696 15.8899C15.0844 15.8899 15.4566 15.4749 15.4566 14.9436C15.4566 14.6946 15.3774 14.4622 15.2032 14.2795L11.4728 10.3616C12.2569 9.28247 12.7242 7.94604 12.7242 6.49341C12.7242 2.98218 9.98387 0.110107 6.6337 0.110107C3.27562 0.110107 0.543213 2.98218 0.543213 6.49341C0.543213 10.0046 3.27562 12.8767 6.6337 12.8767ZM6.6337 11.4988C4.01218 11.4988 1.85793 9.23267 1.85793 6.49341C1.85793 3.75415 4.01218 1.48804 6.6337 1.48804C9.24731 1.48804 11.4095 3.75415 11.4095 6.49341C11.4095 9.23267 9.24731 11.4988 6.6337 11.4988Z"
            fill="#090741"
            fill-opacity="0.75"
          />
        </svg>
      </div>
    </div>
    <dod-filters
      v-if="withFilters"
      :settings="filterSettings"
      @onFilter="handleFilters"
    />

    <dod-month-switcher
      v-if="withMonthSwitcher"
      :date="date"
      @onMonthChange="onMonthChange"
    />
  </div>
</template>
<script>
import DodFilters from "./DodFilters.vue";
import DodMonthSwitcher from "./DodMonthSwitcher.vue";
export default {
  name: "DodSearchInput",
  components: {
    DodFilters,
    DodMonthSwitcher,
  },
  props: {
    placeholder: {
      type: String,
      default: "Szukaj",
    },
    withFilters: {
      type: Boolean,
      default: false,
    },
    filterSettings: {
      type: Array,
      default: () => [],
    },
    date: {
      type: Date,
    },
    withMonthSwitcher: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["search", "onFilter", "onMonthChange"],
  data() {
    return {
      search: "",
      searchTimeout: null,
    };
  },

  watch: {
    search() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 250);
    },
  },

  methods: {
    handleSearch() {
      this.$emit("search", this.search);
    },
    handleFilters(filters) {
      this.$emit("onFilter", filters);
    },
    onMonthChange(date) {
      this.$emit("onMonthChange", date);
    },
  },
};
</script>
<style scoped>
.search-input-container {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 2rem;
}
.search-container {
  width: 100%;
  display: flex;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid rgba(9, 7, 65, 0.3);
  position: relative;
  display: flex;
  align-items: center;
  height: 44px;
  flex-wrap: wrap;
}
.icon {
  position: absolute;
  left: 1rem;
}
input {
  width: 100%;
  border: 0;
  padding-left: 4rem;
  font-size: 16px;
  color: rgba(9, 7, 65, 0.75);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
input:focus {
  border: 0;
  outline: 0;
}
</style>
